import { render } from "./modaleInjury.vue?vue&type=template&id=1080d0a4"
import script from "./modaleInjury.vue?vue&type=script&lang=js"
export * from "./modaleInjury.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__